import { Body1 } from '@cian/ui-kit';

interface IDescriptionRowProps {
  label: string;
  text: string;
  action?(): void;
}

export const DescriptionRow = ({ label, text, action }: IDescriptionRowProps) => {
  return (
    <div>
      {label && <Body1>{label}</Body1>}
      <span>
        <Body1 whiteSpace="pre-line">{text}</Body1>
        {action && (
          <Body1 color="text-main-default" onClick={action}>
            Развернуть
          </Body1>
        )}
      </span>
    </div>
  );
};
